// checkbox组件

<template>
  <span class="bcheckbox" @click="change">
    <span class="bcheckbox-default">
      <span :class="getClass"> </span>
      <!-- <input v-show="currentChecked" type="checkbox"/> -->
    </span>
    <label :for="name" class="checkbox-label">{{ label }}</label>
  </span>
</template>

<script>
export default {
  name: "checkbox",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    name: {
      type: String
    }
  },
  data() {
    return {
      currentChecked: this.value
    };
  },
  watch: {
    value(val) {
      this.currentChecked = val;
    }
  },

  computed: {
    getClass() {
      if (!this.currentChecked) {
        return "checkbox-inner  ";
      } else {
        return "checkbox-inner checkbox-inner-checked";
      }
    }
  },

  methods: {
    change() {
      // debugger;
      this.currentChecked = !this.currentChecked;
      this.$emit("input", this.currentChecked);
      this.$emit("change", this.currentChecked);
    },

    getValue() {
      return this.currentChecked;
    }
  },
  mounted() {
    // this.currentChecked = this.checked
  }
};
</script>

<style lang="scss" scoped>

.bcheckbox {
  display: block;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  .bcheckbox-default {
    vertical-align: middle;
    display: inline-block;
    position: relative;
    white-space: nowrap;
    cursor: pointer;
    margin-right: 5px;
    line-height: 1;
    .checkbox-inner {
      display: inline-block;
      width: 15px;
      height: 15px;
      position: relative;
      top: 0;
      left: 0;
      -webkit-transition: border-color 0.2s ease-in-out,
        background-color 0.2s ease-in-out, -webkit-box-shadow 0.2s ease-in-out;
      transition: border-color 0.2s ease-in-out,
        background-color 0.2s ease-in-out, -webkit-box-shadow 0.2s ease-in-out;
      transition: border-color 0.2s ease-in-out,
        background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
      transition: border-color 0.2s ease-in-out,
        background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out,
        -webkit-box-shadow 0.2s ease-in-out;
      border: 1px solid #2d8cf0;
      // border-radius: 20px;
      background-color: #f9f9f9;
      &.checkbox-inner-checked {
        border: 1px solid #2d8cf0;
        // border-radius: 20px;
        background-color: #2d8cf0;
        &::after {
          content: "";
          display: table;
          width: 6px;
          height: 7px;
          position: absolute;
          top: 2px;
          left: 4px;
          -webkit-transform: rotate(45deg) scale(1);
          -ms-transform: rotate(45deg) scale(1);
          transform: rotate(45deg) scale(1);
          border-color: #fff;
          border-style: solid;
          border-width: 0 2px 2px 0;
          -webkit-border-image: initial;
          -o-border-image: initial;
          border-image: initial;
          border-top: 0;
          border-left: 0;
          -webkit-transition: all 0.2s ease-in-out 0s;
          transition: all 0.2s ease-in-out 0s;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// bCheckBox.vue?8681d7d8